module.exports = __webpack_public_path__ + "assets/img/warrior-name-ddc3112c.png";